import { CACHE_KEY } from '@gef-ui/cdu-user-v2/constants';
import { getCduUserPermissions } from '@gef-ui/cdu-user-v2/selectors';
import { getLabelMessage } from '@gef-ui/localization/messages';
import useCachedQuery from '@gef-ui/middleware-api/hooks/useCachedQuery';
import { useSelector } from 'react-redux';
export const useLoadCduUser = ({ fetchManually } = {})=>{
    const { enable: loadUser, ...result } = useCachedQuery({
        endpoint: '/application/cdu-logged-user-info',
        keepPreviousData: true,
        meta: {
            errorReport: {
                heading: getLabelMessage(`errors:loadCduErrorHeading`),
                shortDescription: getLabelMessage(`errors:loadCduShortDescription`),
                options: {
                    showUnclosableErrorModal: true
                }
            }
        },
        cacheKey: CACHE_KEY,
        enabled: !fetchManually
    });
    return {
        ...result,
        loadUser
    };
};
export const useCheckPermission = ({ permissionResolver })=>{
    const userPermissions = useSelector(getCduUserPermissions);
    return permissionResolver(userPermissions);
};
export default {
    CduUser: {
        useLoadCduUser,
        useCheckPermission
    }
};
